import { render, staticRenderFns } from "./masterUserDetail.vue?vue&type=template&id=1b420dec&scoped=true&"
import script from "./masterUserDetail.vue?vue&type=script&lang=js&"
export * from "./masterUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./masterUserDetail.vue?vue&type=style&index=0&id=1b420dec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b420dec",
  null
  
)

export default component.exports